// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 977) return "static/chunks/977.34c33fbdcea16c78.js";
	if (chunkId === 123) return "static/chunks/123.16cdf57761135c47.js";
	if (chunkId === 113) return "static/chunks/113.6bfe3cfa3d9b20a1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"205":"0afca72ee7b7a48b","335":"6327cc07696df117","338":"4927a76d128dbae7","764":"aa85694fa4f99a4d","781":"3ca117f91f102349"}[chunkId] + ".js";
};